import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { ErrorMessage } from '@change/ds-forms';
import { InfoV2Icon } from '@change/ds-icons';

import { Translate, TypedTranslate } from '@change-corgi/core/react/i18n';

import { ImageCropperUploaderSunriseV2 as ImageCropperUploader } from 'src/app/shared/components/imageUpload';

import type { ImageUploadContainerProps } from '../../types';

import { useImageUploadContainer } from './hooks/useImageUploaContainer';

export const ImageUploadContainer: React.FC<ImageUploadContainerProps> = ({
	uploader,
	disabled = false,
	initialImage,
}) => {
	const {
		data: { errorMessage, image, imageCrop },
		actions: { onImageChange, onImageCrop, dispatch },
	} = useImageUploadContainer({ uploader, initialImage });

	return (
		<div className="flex w-full flex-col">
			<Text variant="heading" size="x-small" className="mb-4">
				<Translate value="corgi.petition.starter_dashboard_v2.post_an_update.form.image_upload_label" />
			</Text>
			<ImageCropperUploader
				uploader={uploader}
				image={image}
				crop={imageCrop}
				disabled={disabled}
				onImageChange={onImageChange}
				onImageCrop={onImageCrop}
				onInitialized={(instance: Cropper) => {
					dispatch({ type: 'cropper/instance', payload: { cropper: instance } });
				}}
			/>
			{errorMessage && (
				<ErrorMessage size="small" className="mt-1" data-testid="upload-error-message">
					<TypedTranslate value={errorMessage} />
				</ErrorMessage>
			)}
			<div className="mt-3 flex w-full flex-row items-center gap-1">
				<InfoV2Icon />
				<Text>
					<Translate value="corgi.petition.starter_dashboard_v2.post_an_update.form.image_upload_tip" />
				</Text>
			</div>
		</div>
	);
};
